import actionTypes from "../actionTypes";

const fetchInfo = () => {
  return {
    type: actionTypes.subscription.FETCH_INFO
  };
}

const fetchInfoOk = (data) => {
  return {
    type: actionTypes.subscription.FETCH_INFO_OK,
    data: data
  };
}

const fetchInfoError = (error) => {
  return {
    type: actionTypes.subscription.FETCH_INFO_ERROR,
    error: error
  };
}

export const subscriptionActions = {
  fetchInfo,
  fetchInfoOk,
  fetchInfoError
};